<template>
  <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12" style="height: 100%;" >
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-content">
            <div class="row p-2">
              <div class="col-md-1 d-flex align-items-center pr-0">
                <div class="ml-10">
                  <label class="ml-3" for=""><b>Year</b></label> <br>
                  <select @change="changeYear($event)" style="height: 31px; border: none">
                    <option :selected="row == year" v-for="(row, index) in years" :key="index" :value="row">{{row}}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-1 d-flex align-items-center pl-0">
                <div>
                  <label for="" class="ml-3"><b>Month</b></label> <br>
                  <select @change="updateLeaderBoard($event)" style="height: 31px; border: none">
                    <option value="all">All </option>
                    <option :disabled="row.value > (new Date().getMonth()) && year == new Date().getFullYear()" :selected="row.value === selectedMonth.value" v-for="(row, index) in allMonths" :key="index" :value="JSON.stringify(row)">{{row.name }} {{row.year}}</option>
                  </select>
                </div>
              </div>
              <!--              <div class="col-md-2 d-flex align-items-center justify-content-between">-->
              <!--                <div class="ml-10">-->
              <!--                  <label for=""><b>Year</b></label> <br>-->
              <!--                  <select v-model="year" style="height: 31px; border: none">{{year}}-->
              <!--                    <option :selected="row === year" v-for="(row, index) in years" :key="index" :value="row">{{row}}</option>-->
              <!--                  </select>-->
              <!--                </div>-->
              <!--                <div>-->
              <!--                  <label for=""><b>Month</b></label> <br>-->
              <!--                  <select @change="updateLeaderBoard($event)" style="height: 31px; border: none">-->
              <!--                    <option value="all">All </option>-->
              <!--                    <option :selected="row.value === selectedMonth.value && row.year=== selectedMonth.year" v-for="(row, index) in allMonths" :key="index" :value="JSON.stringify(row)">{{row.name }} {{row.year}}</option>-->
              <!--                  </select>-->
              <!--                </div>-->
              <!--              </div>-->
              <template v-if="!loading">
                <template v-if="users.length">
                  <div class="col-md-2 col-sm-4">
                    <p class="text-center">Migrations</p>
                    <div :class="topData.inMigration ? 'bg-green' : 'bg-grey'" class="card top-cards">
                      <div class="card-content mb-0">
                        <div class="p-2 d-flex justify-content-between align-items-center">
                          <img width="22%" v-for="(row, index) in topData.migration" :key="index" :title="row.name" :src="`https://www.gravatar.com/avatar/${row.emailHash}?s=50`">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2 col-sm-4">
                    <p class="text-center">Peer Reviews</p>
                    <div :class="topData.inReview ? 'bg-green' : 'bg-grey'" class="card top-cards">
                      <div class="card-content  mb-0">
                        <div class="p-2 d-flex justify-content-between align-items-center">
                          <img width="22%" v-for="(row, index) in topData.review" :key="index" :title="row.name" :src="`https://www.gravatar.com/avatar/${row.emailHash}?s=50`">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2 col-sm-4">
                    <p class="text-center">WPO Tasks</p>
                    <div :class="topData.inSupport ? 'bg-green' : 'bg-grey'" class="card top-cards">
                      <div  class="card-content m-b-0">
                        <div class="p-2 d-flex justify-content-between align-items-center">
                          <img width="22%" v-for="(row, index) in topData.support" :title="row.name" :key="index" :src="`https://www.gravatar.com/avatar/${row.emailHash}?s=50`">
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="col-md-2 col-sm-4">
                    <p class="text-center">Monitors</p>
                    <div :class="topData.inMonitor ? 'bg-green' : 'bg-grey'" class="card top-cards">
                      <div class="card-content mb-0">
                        <div class="p-2 d-flex justify-content-between align-items-center">
                          <img width="22%" v-for="(row, index) in topData.monitor" :title="row.name" :key="index" :src="`https://www.gravatar.com/avatar/${row.emailHash}?s=50`">
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="col-md-2 col-sm-4">
                    <p class="text-center">Remarks</p>
                    <div :class="topData.inTeamRemarks ? 'bg-green' : 'bg-grey'" class="card top-cards">
                      <div class="card-content  mb-0">
                        <div class="p-2 d-flex justify-content-between align-items-center">
                          <img width="22%" v-for="(row, index) in topData.teamRemarks" :title="row.name" :key="index" :src="`https://www.gravatar.com/avatar/${row.emailHash}?s=50`">
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="col-md-10 text-center text-danger mb-3 font-weight-bold">
                    No Data Exists
                  </div>
                </template>
              </template>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="card">
      <div class="card-body" style="padding-top: 0 !important;">
        <div class="row">
          <div class="col-md-12 mt-12" v-if="!loading">
            <teamStats ref="teams" @openModal="openModal" :topData="topData" :loading="loading" :users="users" :allTimeLeaderboardData="allTimeLeaderboardData" :totalNpsScore="totalNpsScore"/>
          </div>
          <template v-else>
            <div class="loader" v-if="loading"></div>
          </template>
        </div>
      </div>
    </div>
    <remarks-modal @renderData="rerenderData" ref="remarksModal"  />

  </div>
</template>

<script>
import {db} from "@/firebase/init";
import copyButtonMixin from "../../../mixins/copyButtonMixin";
import md5 from "crypto-js/md5";

export default {
  name: "index",
  mixins: [copyButtonMixin],
  components: {
    remarksModal: () => import(/* webpackChunkName: "userList" */ "../../../components/Admin/StatisticsPanel/remarksModal"),
    teamStats: () => import(/* webpackChunkName: "userList" */ "../../../components/Admin/StatisticsPanel/teamStats"),
  },
  updated() {
    try{
      if(this.$refs.teams) {
        this.$refs.teams.renderTable()
      }
    }
   catch(error){
     console.log(error.toString())
   }
  },
  async mounted() {
    const date = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York',}));
    console.log('date', date);
    this.mounted = true
    this.month = date.getMonth();
    this.year = date.getFullYear();
    this.selectedMonth = {...this.allMonths.find(el => el.value === this.month), year: this.year}
    console.log('selected month', this.selectedMonth)
    // this.month= (new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York',}))).getMonth()
    // this.year= (new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York',}))).getFullYear()
    // await this.getDataForLeaderboard()
    // await this.calculateTopUsers()
  },
  data() {
    return {
      totalNpsScore : null,
      script: null,
      years: ['All', '2025', '2024', '2023'],
      selectedMonth: {},
      allMonths: [
        { name: 'January', value: 0},
        {name: 'February', value: 1},
        {name: 'March', value: 2},
        {name: 'April', value: 3},
        {name: 'May', value: 4},
        {name: 'June', value: 5},
        {name: 'July', value: 6},
        {name: 'August', value: 7},
        {name: 'September', value: 8},
        {name: 'October', value: 9},
        {name: 'November', value: 10},
        {name: 'December', value: 11},
      ],
      type: 'Migration',
      month: '',
      mounted: false,
      year: null,
      loading: false,
      users: [],
      topData: {
        migration: [],
        review: [],
        support: [],
        monitor: [],
        cfEnterprise: [],
        teamRemarks: [],
        inTeamRemarks: false,
        inMigration: false,
        inMonitor: false,
        inReview: false,
        inSupport: false,
      },
      allMembers: [],
      allTimeLeaderboardData: [],
      allCustomerRemarks: []
    }
  },
  watch: {
    async loading(value) {
      if (!value) {
        const self = this
        // setTimeout(function () {
        //   self.$refs.teams.renderTable()
        // }, 300)
      }
    },
    async month(val) {
      if(this.mounted) {
        this.mounted = false
        return
      }
      console.log('187', val,this.month, this.year)
      this.loading= true
      // this.year = (new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York',}))).getFullYear()
      this.users= []
      this.topData= {
        migration: [],
        review: [],
        support: [],
        monitor: [],
        cfEnterprise: [],
        teamRemarks: [],
        customerRemarks: [],
        inTeamRemarks: false,
        inMigration: false,
        inMonitor: false,
        inReview: false,
        inSupport: false,
      }
      await this.getAllStaffMembers()
      await this.getDataForLeaderboard()
      await this.calculateTopUsers()
      try{
        this.$refs.teams.renderTable()
      }
      catch(error){
        console.log(error.toString())
      }
      this.loading= false

      // const self = this
      // setTimeout(function () {
      //   self.$refs.teams.renderTable()
      // }, 0)
    },
    async year(val) {
      console.log('187', val,this.month, this.year)
      if(this.mounted) {
        this.mounted = false
        return
      }
      this.loading= true
      // this.year = (new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York',}))).getFullYear()
      this.users= []
      this.topData= {
        migration: [],
        review: [],
        support: [],
        monitor: [],
        teamRemarks: [],
        customerRemarks: [],
        cfEnterprise: [],
        inTeamRemarks: false,
        inMigration: false,
        inMonitor: false,
        inReview: false,
        inSupport: false,
      }
      await this.getAllStaffMembers()
      await this.getDataForLeaderboard()
      await this.calculateTopUsers()
      try{
        this.$refs.teams.renderTable()
      }
      catch(error){
        console.log(error.toString())
      }
      this.loading= false

      // const self = this
      // setTimeout(function () {
      //   self.$refs.teams.renderTable()
      // }, 0)
    },
  },
  computed: {
    getMonths() {
      const allMonths = [...this.allMonths.map(el => {return {...el, year: 2024}}), ...this.allMonths.map(el => {return {...el, year: 2023}})]
      return allMonths.filter(el => (el.value <= (new Date()).getMonth() && el.year === new Date().getFullYear()) || el.year < new Date().getFullYear()).sort((a, b) => {
        // First, compare by year
        if (a.year !== b.year) {
          return b.year - a.year;
        }
        // If years are the same, compare by month
        return b.value - a.value;
      })
    }
  },
  methods: {
    changeYear(e) {
      console.log('year', this.year, this.month)
      this.year = e.target.value
      if(this.year === 'All') {
        this.year = 'all'
      }
      console.log('yearrrrrrr', this.year, this.month)

    },
    updateLeaderBoard(row) {
      if(row.target.value === 'all') {
        this.month = 'all';
      } else {
        console.log('223', row.target.value)
        const object = JSON.parse(row.target.value)
        this.month = object.value
        console.log('227', this.year, this.month)
      }
    },
    async rerenderData() {
      this.month = (new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York',}))).getMonth()
      this.loading= true
      this.year = (new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York',}))).getFullYear()
      this.users= []
      this.topData= {
        migration: [],
        review: [],
        support: [],
        monitor: [],
        teamRemarks: [],
        customerRemarks: [],
        cfEnterprise: [],
        inTeamRemarks: false,
        inMigration: false,
        inMonitor: false,
        inReview: false,
        inSupport: false,
      }
      await this.getAllStaffMembers()
      await this.getDataForLeaderboard()
      await this.calculateTopUsers()
      this.loading= false

      // const self = this
      // setTimeout(function () {
      //   self.$refs.teams.renderTable()
      // }, 0)
    },
    async openModal(data){
      let remarksList = [];
      if(data.type.includes('Team')) {
        remarksList = data.selectedTeamRemarks;
        await this.getAllStaffMembers()
      } else if (data.type.includes('Customer')) {
        remarksList = data.selectedCustomerRemarks;
      }
      this.$refs.remarksModal.load(data.type, this.allMembers,  remarksList, data.adminUid , data.month)
    },
    async getDataForLeaderboard(){
      try {
        console.log('307', typeof (this.month), typeof (this.year))
        this.loading = true;
        let ref= null
        this.users=[]
        let usersArray = [];
        let allTimeLeaderboard = [];
        if(this.month === 'all' && this.year === 'all'){
          ref= await db.collection('leaderboard').doc('all-time-leaderboard').get();
          if(ref.exists) {
            const { users } = ref.data();
            if(users.length) {
              // for(const row of users) {
              //   const userRef = await db.collection('users').doc(row.uid).get()
              //   row.email = userRef.data().email
              //   row.emailHash = await row.email ?  md5(row.email.trim().toLowerCase()).toString() : ''
              //   console.log(row.emailHash)
              // }
              // await db.collection('leaderboard').doc('all-time-leaderboard').update({users})
              usersArray = users;
              allTimeLeaderboard = users
              console.log('users', usersArray)
            }
          }
        } else if(this.month === 'all' && this.year !== 'all') {
          console.log('in here', )
          ref= await db.collection('leaderboard').where('year','==', Number(this.year)).get();
          console.log('size', ref.size)
          if(ref.size) {
            const allUsers = []
            ref.forEach(el => {
              allUsers.push(el.data())
            })
            for(const row of allUsers) {
              console.log('row', row)
              if(row.users && row.users.length){
                for(const row1 of row.users) {
                  const obj = usersArray.find(el => el.email === row1.email);
                  console.log('344', obj)
                  row1.cfEnterprise = row1.cfEnterprise ? row1.cfEnterprise : 0;
                  if(obj) {
                    obj.customerRemarks += row1.customerRemarks;
                    obj.customerRemarksDetails = [...obj.customerRemarksDetails, ...row1.customerRemarksDetails];
                    obj.migration += row1.migration;
                    obj.monitor += row1.monitor;
                    obj.review += row1.review;
                    obj.cfEnterprise += row1.cfEnterprise;
                    obj.support += row1.support;
                    obj.teamRemarks += row1.teamRemarks;
                    obj.teamRemarksDetails = [...obj.teamRemarksDetails, ...row1.teamRemarksDetails]
                    console.log('350', obj)
                  } else {
                    usersArray.push(row1);
                  }
                }
              }
            }
            // const { users } = ref.docs[0].data();
            // if(users.length) {
            // for(const row of users) {
            //   const userRef = await db.collection('users').doc(row.uid).get()
            //   row.email = userRef.data().email
            //   row.emailHash = await row.email ?  md5(row.email.trim().toLowerCase()).toString() : ''
            //   console.log(row.emailHash)
            // }
            // this.users = users;
            // usersArray = users
            // console.log('users', users)
            // }
            const leaderboardRef = await db.collection('leaderboard').doc('all-time-leaderboard').get();
            if (leaderboardRef) {
              const { users } = leaderboardRef.data();
              allTimeLeaderboard = users
            }
          }
        } else if(this.year === 'all' && this.month !== 'all') {
          console.log('in here secondd', )
          ref= await db.collection('leaderboard').where('month','==', Number(this.month)).get();
          console.log('size', ref.size)
          if(ref.size) {
            const allUsers = []
            ref.forEach(el => {
              allUsers.push(el.data())
            })
            console.log('all users', allUsers)
            for(const row of allUsers) {
              console.log('row', row)
              if(row.users && row.users.length){
                for(const row1 of row.users) {
                  const obj = usersArray.find(el => el.email === row1.email);
                  row1.cfEnterprise = row1.cfEnterprise ? row1.cfEnterprise : 0;
                  console.log('344', obj)
                  if(obj) {
                    obj.customerRemarks += row1.customerRemarks;
                    obj.customerRemarksDetails = [...obj.customerRemarksDetails, ...row1.customerRemarksDetails];
                    obj.migration += row1.migration;
                    obj.monitor += row1.monitor;
                    obj.review += row1.review;
                    obj.support += row1.support;
                    obj.teamRemarks += row1.teamRemarks;
                    obj.cfEnterprise += row1.cfEnterprise;
                    obj.teamRemarksDetails = [...obj.teamRemarksDetails, ...row1.teamRemarksDetails]
                    console.log('350', obj)
                  } else {
                    usersArray.push(row1);
                  }
                }
              }
            }
            const leaderboardRef = await db.collection('leaderboard').doc('all-time-leaderboard').get();
            if (leaderboardRef) {
              const { users } = leaderboardRef.data();
              allTimeLeaderboard = users
            }
          }
        }else {
          ref= await db.collection('leaderboard').where('month', '==', Number(this.month)).where('year','==', Number(this.year)).get();
          console.log('ref.', ref.size)
          if(ref.size) {
            const { users } = ref.docs[0].data();
            if(users.length) {
              // for(const row of users) {
              //   const userRef = await db.collection('users').doc(row.uid).get()
              //   row.email = userRef.data().email
              //   row.emailHash = await row.email ?  md5(row.email.trim().toLowerCase()).toString() : ''
              //   console.log(row.emailHash)
              // }
              // this.users = users;
              usersArray = users
              // console.log('users', users)
            }
            const leaderboardRef = await db.collection('leaderboard').doc('all-time-leaderboard').get();
            if (leaderboardRef) {
              const { users } = leaderboardRef.data();
              allTimeLeaderboard = users
            }
          }
        }
        for(const row of this.allMembers){
          const obj = usersArray.find(el => el.uid === row.uid)
          if(obj) {
            obj.cfEnterprise = obj.cfEnterprise ? obj.cfEnterprise : 0;
            continue
          }
          usersArray.push({
            migration: 0,
            review: 0,
            support: 0,
            monitor: 0,
            teamRemarks: 0,
            customerRemarks: 0,
            cfEnterprise: 0,
            teamRemarksDetails: [],
            customerRemarksDetails: [],
            uid: row.uid,
            email: row.email,
            emailHash: row.email ?  md5(row.email.trim().toLowerCase()).toString() : '',
            name: row.firstName + ' ' + row.lastName,})
        }
        console.log('498', usersArray)
        await this.getCustomerRemarks(usersArray);
        this.allTimeLeaderboardData = allTimeLeaderboard
        this.users= usersArray.map((value) => ({...value, cfEnterprise: value.cfEnterprise || 0}))
      }catch (e) {
        console.log('errror on ine 250', e.toString())
      }
      finally {
        this.loading = false;
      }
    },
    async getAllStaffMembers() {
      try {
        this.allMembers=[]
        const ref = await db.collection("users").where("userType", "in", ['admin', 'manager', 'super-admin']).get();
        if(ref.size) {
          ref.forEach(el => {
            this.allMembers.push({uid: el.id, ...el.data()})
          })
          // this.allMembers = this.allMembers.filter(el => !el.email.includes('sara@bigscoots.com'))
          console.log('all members', this.allMembers)
        }
      }
      catch (e) {
        console.log(e.toString())
      }
    },
    calculateTopUsers() {
      try {
        this.topData.migration=(this.users.sort((a, b) => {
          if (a.migration < b.migration) {
            return 1
          }
          if (a.migration > b.migration) {
            return -1
          }
          return 0
        })).slice(0, 4);
        this.topData.inMigration = this.topData.migration.find(el => el.uid === this.user.uid) ? true : false
        this.topData.review=(this.users.sort((a, b) => {
          if (a.review < b.review) {
            return 1
          }
          if (a.review > b.review) {
            return -1
          }
          return 0
        })).slice(0, 4);
        this.topData.inReview = this.topData.review.find(el => el.uid === this.user.uid) ? true : false


        this.topData.support=(this.users.sort((a, b) => {
          if (a.support < b.support) {
            return 1
          }
          if (a.support > b.support) {
            return -1
          }
          return 0
        })).slice(0, 4);

        this.topData.inSupport = this.topData.support.find(el => el.uid === this.user.uid) ? true : false

        this.topData.monitor=(this.users.sort((a, b) => {
          if (a.monitor < b.monitor) {
            return 1
          }
          if (a.monitor > b.monitor) {
            return -1
          }
          return 0
        })).slice(0, 4);
        this.topData.inMonitor= this.topData.monitor.find(el => el.uid === this.user.uid) ? true : false
        this.topData.teamRemarks=(this.users.sort((a, b) => {
          if (a.teamRemarks < b.teamRemarks) {
            return 1
          }
          if (a.teamRemarks > b.teamRemarks) {
            return -1
          }
          return 0
        })).slice(0, 4);
        this.topData.inTeamRemarks= this.topData.teamRemarks.find(el => el.uid === this.user.uid) ? true : false
        this.topData.customerRemarks=(this.users.sort((a, b) => {
          if (a.customerRemarks < b.customerRemarks) {
            return 1
          }
          if (a.customerRemarks > b.customerRemarks) {
            return -1
          }
          return 0
        })).slice(0, 4);
        this.topData.cfEnterprise=(this.users.sort((a, b) => {
          if (a.cfEnterprise < b.cfEnterprise) {
            return 1
          }
          if (a.cfEnterprise > b.cfEnterprise) {
            return -1
          }
          return 0
        })).slice(0, 4);
        // this.topData.inCustomerRemarks= this.topData.customerRemarks.find(el => el.uid === this.user.uid) ? true : false
      }
      catch (e) {
        console.log('error on line 320', e.toString())
      }
    },
    // calculateNps(data){
    //   let totalCustomerFeedback = 0;
    //   let totalPromoters = 0;
    //   let totalDetractors = 0;
    //   const updatedArray= data.map((value)=>{
    //
    //     const totalFeedback= value.customerRemarks;
    //     if(Object.keys(value).includes('promoter') && Object.keys(value).includes('detractor')  ){
    //       totalCustomerFeedback= totalCustomerFeedback+ totalFeedback;
    //       totalPromoters= totalPromoters + Number(value.promoter);
    //       totalDetractors= totalDetractors + value.detractor;
    //       value.npsValue=  Math.round(((value.promoter / totalFeedback)*100) - ((value.detractor / totalFeedback) * 100));
    //     }
    //   })
    //
    //   if (!(totalCustomerFeedback || totalPromoters || totalDetractors)) {
    //     this.totalNpsScore=0;
    //   }
    //   else{
    //     this.totalNpsScore=Math.round(((totalPromoters / totalCustomerFeedback)*100) - ((totalDetractors / totalCustomerFeedback) * 100));
    //   }
    //
    //   return updatedArray;
    //
    // },
    async getCustomerRemarks(users){
      this.allCustomerRemarks = [];
      let ref= db.collection('customerRemarks').where('status', '==', 'completed');
      console.log(this.month)
      if(this.month === 'all' && this.year === 'all') {
        ref= await ref.get();
      }
      else if(this.month !== 'all' && this.year === 'all') {
        ref= await ref.where('month', '==', Number(this.month)).get()
      }
      else if(this.month === 'all' && this.year !== 'all') {
        ref= await ref.where('year', '==', Number(this.year)).get()
      }
      else {
        ref= await ref.where('month', '==', Number(this.month)).where('year', '==', Number(this.year)).get()
      }
      ref.forEach(el => {
        this.allCustomerRemarks.push({id: el.id, ...el.data()});
      })
      let totalNps = null;
      for (const row of users) {
        if(row.uid === 'HvRF53vIKMfhb8NaW4SuzWUlk4w1') {
          console.log('justin row', row)
        }
        row.allCustRemarks = [];
        row.allCustRemarks = this.allCustomerRemarks.filter(el => el.staffMemberDetails.uid === row.uid);
        row.npsVal = await this.calcNps(row.allCustRemarks);
      }
      this.totalNpsScore = await this.calcNps(this.allCustomerRemarks)
      console.log('nps', totalNps);
      console.log('staff members', this.allMembers);
    },
    calcNps(allCustRemarks){
      let npsVal = null;
      let promotor = 0;
      let detractor = 0;
      if (allCustRemarks.length) {
        // get those which are latest
        const latestFeedbacks = allCustRemarks.filter(el => el.latestFeedback && (el.status ? el.status === 'completed' : true));
        console.log('latestFeed', latestFeedbacks)
        latestFeedbacks.map(el => {
          if (el.reaction === 'excellent') {
            promotor += 1;
          } else if (el.reaction === 'hate') {
            detractor += 1;
          }
        })
        npsVal =  Math.round(((promotor / latestFeedbacks.length)*100) - ((detractor / latestFeedbacks.length) * 100));
      } else {
        npsVal = null;
      }
      return npsVal;
    }

  }
}
</script>
<style scoped>
.top-cards{
  border-radius: 40px;
}
.bg-green{
  background: #3DBC99;
}
.bg-grey{
  background: #DEE2ED;
}
.avatar-h-w{
  height: 49px;
  width: 49px;
  margin-bottom: 0px;
}
img {
  border-radius: 50%;
}
::v-deep .dataTables_info{
  margin-top: -66px !important;
}
</style>
